import script from "./AccountDenialModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountDenialModal.vue?vue&type=script&setup=true&lang=js"

import "./AccountDenialModal.vue?vue&type=style&index=0&id=79ef0c04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ef0c04"]])

export default __exports__